import { SequenceRepository } from "@core/sequence.repository";
import { StorageService } from "@core/services/storage-service";
import { UiService } from "@core/services/ui.services";
import { Logger, ServiceLocator } from "@policoders/di";
import {
  AlertModalService,
  BreadcrumbService,
  FlashMessageService,
  ModalService,
  SubModalService,
} from "@policoders/ds";
import LoaderService from "@shared/components/loader/loader.service";
import NavbarService from "@shared/components/navbar/navbar.service";

const locator = new ServiceLocator();

locator.register("Logger", Logger);
locator.register("BreadcrumbService", BreadcrumbService);
locator.register("NavbarService", NavbarService);

locator.register("AlertModalService", AlertModalService);
locator.register("FlashMessageService", FlashMessageService);
locator.register("ModalService", ModalService);
locator.register("LoaderService", LoaderService);
locator.register("SubModalService", SubModalService);
locator.register("StorageService", StorageService);

locator.registerInstance(
  "UiService",
  new UiService(
    locator.resolve<ModalService>("ModalService"),
    locator.resolve<SubModalService>("SubModalService"),
    locator.resolve<AlertModalService>("AlertModalService"),
    locator.resolve<LoaderService>("LoaderService"),
    locator.resolve<FlashMessageService>("FlashMessageService"),
  ),
);

locator.register("SequenceRepository", SequenceRepository);

export const mainLocator = locator;
